<template>
  <div ref="lineChart" class="line-chart" :style="{ height: chartHeight }"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    chartData: {
      type: Array,
      default: [],
      // required: true,
    },
    chartLabels: {
      type: Array,
      default: [],
      // required: true,
    },
    chartHeight: {
      type: String,
      default: "400px",
    },
  },
  watch: {
    chartData(newData) {
      this.updateChart(newData, this.chartLabels);
    },
    chartLabels(newLabels) {
      this.updateChart(this.chartData, newLabels);
    },
  },
  mounted() {
    this.initChart();
    this.updateChart(this.chartData, this.chartLabels);
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    updateChart(labels, data) {
      console.log(labels, data);
      if (this.chartInstance) {
        console.log(this.chartInstance);
        this.chartInstance.setOption({
          grid: {
            left: "17%",
            right: "4%",
            top: "10%",
            bottom: "14%",
          },
          title: {
            text: "项目流程",
          },
          tooltip: {},
          xAxis: {
            type: "category",
            data: labels,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "金额",
              type: "line",
              data: data,
              smooth: true, // 平滑曲线
              lineStyle: {
                color: "#545454", // 线条颜色
              },
              itemStyle: {
                color: "#ff7f50", // 数据点颜色
              },
              areaStyle: {
                color: "rgba(255, 156, 110, 0.3)", // 填充颜色
              },
            },
          ],
        });
      }
    },
    initChart() {
      this.chartInstance = echarts.init(this.$refs.lineChart);
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
  },
};
</script>

<style scoped>
.line-chart {
  width: 100%;
}
</style>
